<template>
  <div style="height: 100vh; display:flex; flex-direction: column;">
  <v-card style="max-width: fit-content !important; padding: 20px !important;" class="migrate-card">
  <div v-if="!getAuthToken" class="migrate-body" style="margin: auto">
    <h1 class="responsive-header" style="margin-bottom: 30px">
      {{ giftCardMigration ? $vuetify.lang.t('$vuetify.migrate.realFruitLogin') : $vuetify.lang.t('$vuetify.migrate.login') }}
    </h1>
    <login />
    <p style="font-size: 12px; margin-top: 20px; text-align: left;">
      Those accounts with prior gift card balances will be automatically linked to your new account. Enjoy earning points and redemptions by keeping your account active!
      <br/>
      <br/>
    </p>
    <p v-if="isRealFruit" style="font-size: 10px; text-align: left;">
      Real Fruit Bubble Tea may modify the Program at any time and we reserve all rights, including the right to terminate the program or accounts for violations. For more information, visit 
      <a href="https://www.realfruitbubbletea.com" style="color: blue; text-decoration: underline;" target="_blank">www.realfruitbubbletea.com</a> or email us at 
      <a href="mailto:loyal@realfruitbubbletea.com" style="color: blue; text-decoration: underline;">loyal@realfruitbubbletea.com</a>.
    </p>
  </div>
  <div v-else-if="!guestDetails">
    <h1 style="margin-bottom: 30px">
      <template v-if="!hideExternalId && !hideEmail">
        {{ $vuetify.lang.t('$vuetify.migrate.selectOfTwo') }}
      </template>
      <template v-else-if="hideExternalId">
        {{ $vuetify.lang.t('$vuetify.migrate.enterEmail') }}
      </template>
      <template v-else>
        {{ $vuetify.lang.t('$vuetify.migrate.enterId') }}
      </template>
    </h1>

    <masked-input v-if="!hideExternalId"
      ref="externalId"
      :label="giftCardMigration ? $vuetify.lang.t('$vuetify.migrate.giftCard') : $vuetify.lang.t('$vuetify.migrate.externalId')"
      :hint="giftCardMigration ? $vuetify.lang.t('$vuetify.migrate.giftCardHint') : $vuetify.lang.t('$vuetify.migrate.externalIdHint')"
      icon="badge"
      :error-messages="errors['externalId']"
      :raw.sync="externalId"
    />

    <masked-input v-if="!hideEmail"
      ref="Email"
      :label="$vuetify.lang.t('$vuetify.migrate.email')"
      :hint="$vuetify.lang.t('$vuetify.migrate.emailHint')"
      icon="email"

      validation="validateEmail"
      :error-messages="errors['emailError']"
      :raw.sync="email"
    />
    

    <v-btn style="width: 100%" color="accent" :loading="inprogress" @click="submitInfo">
      {{ $vuetify.lang.t('$vuetify.common.submit') }}
    </v-btn>

    <v-dialog v-model="showGiftCardDialog" max-width="600px">
      <v-card>
        <div style="display:flex; width: 100%; justify-content: end;">
          <v-btn icon @click="logout">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="text-center py-4" style="padding-top: 10px;">
          <p class="body-1 font-weight-medium dialog-text">
            <strong>{{ totalPoints }} points</strong> and 
            <strong>${{ totalBalance }} balance</strong> have already been successfully migrated to your account {{this.getAuthTelephone}}
          </p>
        </v-card-text>
        <v-card-actions style="justify-content: end;">
          <v-btn color="primary" style="justify-content: end;" class="px-5 import-btn" @click="showGiftCardDialog = false">
            {{giftCardMigration ? 'Add Giftcard' : 'IMPORT MORE' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  <div v-else>
    <h1 style="margin-bottom: 30px">
      {{ $vuetify.lang.t('$vuetify.migrate.confirmDetails') }}
    </h1>

    <div id="guestDetails">
      <div v-for="(guest, index) in guestDetails" :key="index" class="guest-details">
        <div v-if="guest.firstName || guest.lastName">
          {{ $vuetify.lang.t('$vuetify.migrate.name') }}
          <span> {{ guest.firstName }} {{ guest.lastName }} </span>
        </div>

        <div v-if="guest.externalId">
          {{giftCardMigration ? $vuetify.lang.t('$vuetify.migrate.giftCard') : $vuetify.lang.t('$vuetify.migrate.externalId')}}
          <span> {{ guest.externalId }} </span>
        </div>

        <div v-if="guest.email">
          {{ $vuetify.lang.t('$vuetify.migrate.email') }}:
          <span> {{ guest.email }} </span>
        </div>

        <div v-if="'pointBalance' in guest && guest.pointBalance !== null">
          {{ $vuetify.lang.t('$vuetify.migrate.pointsBalance') }}:
          <span> {{ guest.pointBalance }} </span>
        </div>

        <div v-if="'balance' in guest && guest.balance !== null">
          {{ $vuetify.lang.t('$vuetify.migrate.balance') }}:
          <span> {{ guest.balance | currency(true) }} </span>
        </div>

        <div v-if="'tierName' in guest && guest.tierName !== null">
          {{ $vuetify.lang.t('$vuetify.migrate.tier') }}:
          <span> {{ guest.tierName }} </span>
        </div>
      </div>
    </div>

    <div style="margin-top: 20px; width: 100%">
      <button-control
        :returnTo="resetForm"
        :check-validation="() => true"
        :ready-to-proceed="true"
        :on-click="performMigrate"
      >
        <template v-slot:continue>
          {{ $vuetify.lang.t('$vuetify.common.confirm') }}
        </template>
      </button-control>
    </div>
  </div>

  <v-alert v-if="!!migrateError" border="bottom">
    <h2 style="margin-bottom: 20px; color: red">
      {{ $vuetify.lang.t('$vuetify.errorReport.main') }}
    </h2>
    <h4>
      {{ migrateError }}
    </h4>

    <v-btn @click="resetForm" color="error" style="margin-top: 20px; width: 100%">
      {{ $vuetify.lang.t('$vuetify.common.tryAgain') }}
    </v-btn>
  </v-alert>

  <v-alert v-if="!!accountMigrated" border="bottom">
    <h2 style="margin-bottom: 20px">
      {{ $vuetify.lang.t('$vuetify.common.success') }}!
    </h2>
    <h4>
      {{ $vuetify.lang.t('$vuetify.migrate.migrated') }}:
    </h4>

    <!-- <a v-if="OWALink" :href="OWALink">
      <v-btn color="primary" style="margin-top: 20px; width: 100%">
        {{ $vuetify.lang.t('$vuetify.lottery.goShopping') }}
      </v-btn>
    </a> -->

    <v-btn @click="resetForm" color="success" style="margin-top: 20px; width: 100%">
      {{giftCardMigration ? 'OK' : $vuetify.lang.t('$vuetify.migrate.migrateAgain') }}
    </v-btn>
  </v-alert>
  </v-card>
</div>
</template>

<script>
import Login from '../common/Login'
import maskedInput from '../common/maskedInput'
import ButtonControl from '../common/ButtonControl'

import { mapGetters, mapActions, mapMutations } from 'vuex';
import { api } from '@/plugins/api.service'
import { get } from 'lodash'

export default {
  components: { Login, maskedInput, ButtonControl },

  data: () => ({
    hideExternalId: false,
    hideEmail: false,

    externalId: null,
    email: null,
    errors: {},

    inprogress: false,

    guestDetails: null,
    migrateError: null,

    accountMigrated: false,
    giftCardMigration: false,
    showGiftCardDialog: false,
    loading: true,
    totalPoints: 0,
    totalBalance: 0
  }),
   watch: {
    getAuthToken(newVal) {  
      if (this.giftCardMigration && newVal) {
        this.getRecords()
      }
    }
  },
  computed: {
    isRealFruit() {
      const groupId = get(this.getStore, 'groupId')
      if (groupId) {
        return groupId === 'G21800';
      } else {
        return false
      }
    },
    ...mapGetters([ 'getStore', 'getBuild', 'getAuthToken', 'getAuthTelephone', 'OWALink' ])
  },

  methods: {
    logout() {
      this.showGiftCardDialog = false
      this.$api.post('/owa/customer/logout').then(() => {
        this.guestDetails = null;
        this.setAuthToken(null)
        this.setAuthUser(null)
        this.totalPoints = 0,
        this.totalBalance = 0
        this.$bus.$emit('logout')
      })
    },
    getRecords() {
      return api.post(`/rwa/migration/check_loaded_import_infos`, {
        telephone: this.getAuthTelephone,
        storeId: this.getBuild.storeId
      }).then(({data}) => {
        if (data.length) {
          this.showGiftCardDialog = true;
          this.hideEmail = true;
          this.totalPoints = data.reduce((acc, guest) => acc + (guest.pointBalance || 0), 0).toFixed(2);
          this.totalBalance = data.reduce((acc, guest) => acc + (guest.balance || 0), 0).toFixed(2);
        }
        return data;
      })
    },
    submitInfo() {
      if (this.hideExternalId && !this.email) {
        this.$bus.$emit('showAlert', 'Please provide your email', 'error')
        return
      }
      if (this.hideEmail && !this.externalId) {
        this.$bus.$emit('showAlert', 'Please provide your external id', 'error')
        return
      }
      if (!(this.email && !this.errors['emailError']) && !this.externalId) {
        this.$bus.$emit('showAlert', 'Please fill out at least one of the two fields', 'error')
        return
      }

      this.inprogress = true
      return api.post(`/rwa/migration/check_unloaded_import_infos`, {
        email: this.email,
        externalId: this.externalId,
        telephone: this.getAuthTelephone,
        storeId: this.getBuild.storeId
      }).then(({data}) => {
        this.guestDetails = data.filter(guest => {
          return guest.pointBalance !== null || guest.balance !== null
        })
        this.inprogress = false
        return data
      }).catch((error) => {
        const errorMsg = get(error, 'res.data.errorMsg') || get(error, 'response.data.errorMsg')
        this.migrateError = errorMsg
        this.inprogress = false
      })
    },

    resetForm() {
      this.externalId = null
      this.email = null
      this.migrateError = null

      location.reload();
    },

    performMigrate() {
      if (!(this.email && !this.errors['emailError']) && !this.externalId) {
        this.$bus.$emit('showAlert', 'Please fill out at least one of the two fields', 'error')
        return
      }

      this.inprogress = true
      return api.post(`/rwa/migration/migrate`, {
        email: this.email,
        externalId: this.externalId,
        telephone: this.getAuthTelephone,
        storeId: this.getBuild.storeId
      }).then(({data: guest}) => {
        this.accountMigrated = true
        this.inprogress = false

        return guest
      }).catch((error) => {
        const errorMsg = get(error, 'res.data.errorMsg') || get(error, 'response.data.errorMsg')
        console.log('error', errorMsg);

        this.migrateError = errorMsg
        this.inprogress = false
      })
    },

    ...mapActions([ 'fetchExternalAuth' ]),
    ...mapMutations([ 'setAuthToken', 'setAuthUser' ]),
  },

  mounted() {
    this.fetchExternalAuth()
    const store = this.getStore
    if (store.groupId == 'G21800') {
      this.giftCardMigration = true;
      if (!this.guestDetails && this.getAuthToken) {
        this.getRecords()
      }
    } else {
      this.loading = false;
    }
    this.hideExternalId = this.$route.query.hideExternalId == 'true'
    this.hideEmail = this.$route.query.hideEmail == 'true'
  }
}
</script>

<style scoped>
  .migrate-body {
      width: 350px !important;
  }
  @media (max-width: 380px) {
    .migrate-card {
      margin-top: 10vh !important;
    }
  }
  @media (max-width: 768px) {
    .migrate-body {
      width: auto !important;
    }
    .responsive-header {
      font-size: 1.5rem
    }
  }
  .responsive-header {
    margin-bottom: 30px;
    text-align: center;
    font-size: 1.5rem; 
    line-height: 1.2; 
  }

  .v-alert {
    position: absolute;
    top: 40%;
    left: calc(50% - 175px);

    width: 350px;
  }
  a {
    text-decoration: none;
  }

  #guestDetails>div {
    width: 100%;
    text-align: left;
    padding: 5px 0px;

    font-size: 18px;
    font-weight: 700;
  }
  #guestDetails span {
    font-weight: 500 !important;
  }
  .dialog-text {
    font-size: 18px;
    line-height: 1.5;
    color: #333; 
    margin-bottom: 16px; 
  }

  .import-btn {
    background-color: #4CAF50;
    color: white;
    font-weight: 600;
    font-size: 16px;
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  }

  .import-btn:hover {
    background-color: #45a049;
  }
  .bold-text {
    font-weight: bold;
  }

</style>
